
function   aggregate_database_targets(databases) {
    
  var results = [];    
    
  // get a list of distinct scenarioNames
  var scenarioNames = new Set();
  for (var dbrow=0; dbrow< databases.length ; dbrow++) {
      // only worry about scenarios where odbAWS_algo==Y and odbAWS_service!="adbs-tp"
      if (databases[dbrow].frozen_prefs.odbAWS_algo=="Y" && databases[dbrow].frozen_prefs.odbAWS_service!="adbs-tp") {
          scenarioNames.add(databases[dbrow].scenarioName);
      }      
  }      
  
  
  var scenarios = [...scenarioNames];
  for (var scen=0; scen< scenarios.length; scen++) {
  
      var VCPU_total = 0;
      var  Memory_total = 0;
      var  IOPS_total = 0;
      var  Throughput_total = 0;
      var  storage_total = 0;
      var  hasRAC = false;
      var frozen_prefs = {};
      var assumptions = [];
      
      // Todo: this could be a place where we do a check to avoid counting both CDB and child PDB together
      // downside of doing it here is that we would not be doing similar logic on the RDS side.  So, totals for RDS would include both PDB and CDB.
      // Might be better to find a way to avoid double-counting CDB and child PDB upstream so that both RDS and Exadata calcs are comparable
      
      // need to group by scenarioName as we do this
      for (var groupi=0; groupi< databases.length ; groupi++) {
        if (databases[groupi].scenarioName == scenarios[scen]) {  
            
          // add any unique databases[groupi].assumptions[] to assumptions
            
          //do we include it in the totals?
          if ( ( databases[groupi].PDBandCDBmatch==undefined ) ||
            ( (databases[groupi].frozen_prefs.pdb_and_cdb_exclude_algo == "none") || 
              ( (databases[groupi].frozen_prefs.pdb_and_cdb_exclude_algo == "excludePDB") && (databases[groupi].PDBandCDBmatch!="PDBwithParent") ) || 
              ( (databases[groupi].frozen_prefs.pdb_and_cdb_exclude_algo == "excludeCDB") && (databases[groupi].PDBandCDBmatch!="CDBwithChild") )
            )
          ) {
              
            // also make sure it isnt a read replica-- we skip those
            
            if ( (databases[groupi].ReadReplica!=undefined) && (databases[groupi].ReadReplica=='Y')) {
                // this is a read replica
                // do nothing
    
            } else {

               // console.log("aggregate_database_targets", groupi, databases[groupi], databases[groupi].scenarioName);
              // console.log("including database into infrastructure", groupi, databases[groupi].PDBandCDBmatch, databases[groupi].frozen_prefs.pdb_and_cdb_exclude_algo);
    
                var thisVCPU = 0;
                if ((databases[groupi].OrigVCPU != undefined) && (databases[groupi].VCPU != databases[groupi].OrigVCPU)) {
                    thisVCPU = databases[groupi].OrigVCPU*1;
                } else {    
                  thisVCPU = databases[groupi].VCPU*1;
                }  
                
                if (databases[groupi].frozen_prefs.odbAWS_service=="adb") {
                    // minimum ECPU is 2. The minimum ECPU value for an Autonomous Database is 2.
                    // https://docs.oracle.com/en/cloud/paas/autonomous-database/dedicated/crsrb/index.html#GUID-CB63636B-0D29-4C75-B193-37F125DF4B26
    
                    // ECPU needs to be an integer. For databases that need 1 or more OCPUs or 2 or more ECPUs, you must specify the number of assigned CPUs as an integer. For example, you cannot assign 3.5 ECPUs to a database. The next available number of ECPUs above 3 is 4.
                    // https://docs.oracle.com/en/cloud/paas/autonomous-database/dedicated/adbba/
    
                    // and we could add NodeReservation here too.
                    // temporarily convert to VCPU to OCPU to ECPU
                    thisVCPU = (thisVCPU /2) * 4;
                    if (thisVCPU<2) { thisVCPU=2; }
                    thisVCPU = Math.ceil(thisVCPU);
                    //convert back to VCPU
                    thisVCPU = (thisVCPU/4) * 2;
                }
                
                VCPU_total += thisVCPU;
                
                if ((databases[groupi].OrigMemory != undefined) && (databases[groupi].Memory != databases[groupi].OrigMemory)) {
                    Memory_total += databases[groupi].OrigMemory*1;
                } else {    
                  Memory_total += databases[groupi].Memory*1;
                }  
                
                
                if (databases[groupi].Throughput!=databases[groupi].OrigThroughput) {
                    // console.log("throughput", databases[groupi].Throughput, databases[groupi].OrigThroughput);
                    Throughput_total += databases[groupi].OrigThroughput*1;
                } else {
                    Throughput_total += databases[groupi].Throughput*1;
                }
                if (databases[groupi].IOPS!=databases[groupi].OrigIOPS) {
                    // console.log("IOPS_total", databases[groupi].IOPS, databases[groupi].OrigIOPS);
                    IOPS_total += databases[groupi].OrigIOPS*1;
                } else {
                    IOPS_total += databases[groupi].IOPS*1;
                }
                
                if (databases[groupi].frozen_prefs.odbAWS_service=="adb") {
                    if (databases[groupi].DiskSpace*1 < 32) {
                        storage_total += 32 // minimum database size.  https://docs.oracle.com/en/cloud/paas/autonomous-database/dedicated/adbba/
                    } else {
                        storage_total += databases[groupi].DiskSpace*1;
                    }
                } else {
                  storage_total += databases[groupi].DiskSpace*1;
                }  
                frozen_prefs = databases[groupi].frozen_prefs;
                
                if (databases[groupi].NUM_INSTANCES*1 > 1) {
                    hasRAC = true;
                }
            
            }
          } else {
             //  console.log("excluded database from infrastructure", groupi, databases[groupi].PDBandCDBmatch);
          }    
        }     
      }
      
      assumptions = [
          ...new Map(
            databases
              .filter(database => database && (database.scenarioName == scenarios[scen]) )
              .flatMap(database => database.assumptionsArray)
              .filter(assumption => 
                assumption && 
                assumption.category != null && 
                assumption.text != null &&
                ( (assumption.category != "ExadataTuning") && (assumption.category != "ExadataIOThreshold") && (assumption.category != "ExadataMemory") && (assumption.category != "LicenseVsCost"))
              )
              .map(assumption => [
                `${assumption.category}-${assumption.text}`,
                assumption
              ])
          ).values()
        ];
        
        
      // possibly filter out Exadata Assumptions (these are only relevant to RDS, not ODB)
    
      //add additional assumptions specific to ODB
      // Currently all the ODB assumptions get spelled out in the other columns of the CSV
      // if (frozen_prefs.odbAWS_HA=="Y") assumptions.push({category: "LocalNVME", text: "Only consider shapes with local storage (e.g. r5d,m5d,r6id,...)"});


      // console.log("assumptions for ODB", assumptions, scenarios[scen]);    
      var assumptionsString = "";   

      for (var i of assumptions) {
          assumptionsString += "<b>"+i.category+"</b>: "+ i.text+". <br/>";
      }

  
    
      results.push(
        {
        scenarioName: scenarios[scen],
        frozen_prefs: frozen_prefs,
        VCPU_total: VCPU_total,
        Memory_total: Memory_total,
        IOPS_total: IOPS_total,
        Throughput_total: Throughput_total,
        storage_total: storage_total,
        hasRAC: hasRAC,
        assumptionsArray: assumptions,
        assumptionsString: assumptionsString
        }
       )  ;
  }
  
  return results;
}







function   pick_exadata_shape(exaTargets) {
    
    // Jan8 - right now there is 1 loop, but at the end we duplicate rows to account for MAZ (and soon DR)
    // we really should have 2 loops.  First loop populate infrastructure[] array.
    // second new loop goes through infrastructure[] array and assigns shape
    // first loop is essentially define the infra instances needed (1 or more depending on MAZ and DR)
    // second loop is real pick_exadata_shape
    
  var infrastructure = [];    
  var infraRow = 0;

  for (var scen=0; scen< exaTargets.length ; scen++) {

      // Skip ExaScale scenarios — those are handled by pick_exascale_shape
      if (exaTargets[scen].frozen_prefs.odbAWS_service == "exascale") { continue; }
  
      infrastructure.push ( 
       {
        row: "("+exaTargets[scen].scenarioName+")",
        model: exaTargets[scen].frozen_prefs.odbAWS_model,
        service: "exacs-dedicated",
        role: "Primary",
        dbservers: 2,
        storageservers: 3,
        // UsageUnits_target: 5.3,
        Usage_units: "OCPU",
        UsageUnits_available: 512,
        Usage_comments: "",
        Memory_comments: "",
        assumptionsString: exaTargets[scen].assumptionsString,
        assumptionsArray: exaTargets[scen].assumptionsArray,
        storage_comments: "",
        storage_style: "no_FRA",
        // storage_target: 56123,
        storage_data_dg: 45321,
        storage_reco_dg: 0,
        storage_sparse_dg: 0,
        // IOPS_target: 123223,
        // Throughput_target: 12532,
        // Memory_target: 1234,
        databases: [0,1,2,3],
        scenarioName: exaTargets[scen].scenarioName,
        manual: "NO"
       }
      );
      
       infrastructure[infraRow].UsageUnits_target = Math.round( exaTargets[scen].VCPU_total /2 * 100) / 100;
       infrastructure[infraRow].Usage_comments += "Converted " + Math.round( exaTargets[scen].VCPU_total * 100) / 100 + " VCPUs into " +
            infrastructure[infraRow].UsageUnits_target +" OCPUs. ";
       if (infrastructure[infraRow].model=="X11M") {
           infrastructure[infraRow].Usage_units="ECPU";
           infrastructure[infraRow].Usage_comments += "Converted " + infrastructure[infraRow].UsageUnits_target + " X11M OCPUs into " +
              infrastructure[infraRow].UsageUnits_target*4 +" ECPUs. ";
           infrastructure[infraRow].UsageUnits_target = infrastructure[infraRow].UsageUnits_target *4;
       }        
       infrastructure[infraRow].VCPU_total = exaTargets[scen].VCPU_total;
       infrastructure[infraRow].Memory_target = exaTargets[scen].Memory_total;
       infrastructure[infraRow].IOPS_target = exaTargets[scen].IOPS_total;
       infrastructure[infraRow].Throughput_target = exaTargets[scen].Throughput_total;
       infrastructure[infraRow].storage_target = exaTargets[scen].storage_total;
       infrastructure[infraRow].frozen_prefs = exaTargets[scen].frozen_prefs;

      if (exaTargets[scen].frozen_prefs.odbAWS_service == "adb") {
          infrastructure[infraRow].service = "adb-dedicated";
          
      }
      
      

       var origRow = infraRow;  
       // if this is full-size HA (or any HA with ADB), then duplicate the row for MAZ Standby
       if ( (infrastructure[infraRow].frozen_prefs.odbAWS_HA == "Y") || ( (infrastructure[infraRow].frozen_prefs.odbAWS_HA == "Y20") && (infrastructure[infraRow].frozen_prefs.odbAWS_service == "adb") ) ) {
         infrastructure[infraRow].multiAZ = "Yes";  
         
         infrastructure.push( JSON.parse(JSON.stringify(infrastructure[infraRow])) );
         // infrastructure[infraRow].row = infrastructure[infraRow].row + "-1";
         infraRow++;
         infrastructure[infraRow].role = "Standby(MAZ)";
         // infrastructure[infraRow].row = infrastructure[infraRow].row + "-2";
         
         
       } else if (infrastructure[infraRow].frozen_prefs.odbAWS_HA == "Y20") {
           // this is pilot light
         infrastructure[infraRow].multiAZ = "Yes";  
         
         infrastructure.push( JSON.parse(JSON.stringify(infrastructure[infraRow])) );
         // infrastructure[infraRow].row = infrastructure[infraRow].row + "-1";
         infraRow++;
         infrastructure[infraRow].role = "Standby-MAZ [PilotLight]";
         // infrastructure[infraRow].row = infrastructure[infraRow].row + "-2";
         infrastructure[infraRow].UsageUnits_target = Math.round(infrastructure[infraRow].UsageUnits_target * 0.2 * 10) / 10;
         infrastructure[infraRow].Usage_comments += "Sizing Usage at 20% of Primary. ";
         
       }

       // if this is DR, then duplicate the row for DR.  Y,Y20, YMA, YMA20
       if ( (infrastructure[infraRow].frozen_prefs.odbAWS_DR == "Y") || ( (infrastructure[infraRow].frozen_prefs.odbAWS_DR == "Y20") && (infrastructure[infraRow].frozen_prefs.odbAWS_service == "adb") ) ) {
         infrastructure[infraRow].DR = "Yes";  
         
         infrastructure.push( JSON.parse(JSON.stringify(infrastructure[origRow])) );
         // infrastructure[infraRow].row = infrastructure[infraRow].row + "-1";
         infraRow++;
         infrastructure[infraRow].role = "DR (2ndRegion)";
         // infrastructure[infraRow].row = infrastructure[infraRow].row + "-2";
         
       } else if (infrastructure[infraRow].frozen_prefs.odbAWS_DR == "Y20") {
         infrastructure[infraRow].DR = "Yes";  
         
         infrastructure.push( JSON.parse(JSON.stringify(infrastructure[origRow])) );
         // infrastructure[infraRow].row = infrastructure[infraRow].row + "-1";
         infraRow++;
         infrastructure[infraRow].role = "DR (2ndRegion) [PilotLight]";
         // infrastructure[infraRow].row = infrastructure[infraRow].row + "-2";
         infrastructure[infraRow].UsageUnits_target = Math.round(infrastructure[infraRow].UsageUnits_target * 0.2 * 10) / 10;
         infrastructure[infraRow].Usage_comments += "Sizing Usage at 20% of Primary. ";
         
       } else if ( (infrastructure[infraRow].frozen_prefs.odbAWS_DR == "YMA") || ( (infrastructure[infraRow].frozen_prefs.odbAWS_DR == "YMA20") && (infrastructure[infraRow].frozen_prefs.odbAWS_service == "adb") ) ) {
         
         infrastructure[infraRow].DR = "Yes";  
         
         infrastructure.push( JSON.parse(JSON.stringify(infrastructure[origRow])) );
         // infrastructure[infraRow].row = infrastructure[infraRow].row + "-1";
         infraRow++;
         infrastructure[infraRow].role = "DR (2ndRegion)";
         // infrastructure[infraRow].row = infrastructure[infraRow].row + "-2";
         
         
         //now add DR-MAZ
         infrastructure.push( JSON.parse(JSON.stringify(infrastructure[infraRow])) );
         infraRow++;
         if ( (infrastructure[infraRow].frozen_prefs.odbAWS_HA == "Y20") &&  (infrastructure[infraRow].frozen_prefs.odbAWS_service != "adb") ) {
           infrastructure[infraRow].role = "DR-MAZ (2ndRegion) [PilotLight]";
           infrastructure[infraRow].UsageUnits_target = Math.round(infrastructure[origRow].UsageUnits_target * 0.2 * 10) / 10;
           infrastructure[infraRow].Usage_comments += "Sizing Usage at 20% of Primary. ";
         } else {
           infrastructure[infraRow].role = "DR-MAZ (2ndRegion)";

         } 

       } else if (infrastructure[infraRow].frozen_prefs.odbAWS_DR == "YMA20") {
         
         // console.log("origRow", origRow, infrastructure[origRow].UsageUnits_target);
         infrastructure[infraRow].DR = "Yes";  
         
         infrastructure.push( JSON.parse(JSON.stringify(infrastructure[origRow])) );
         // infrastructure[infraRow].row = infrastructure[infraRow].row + "-1";
         infraRow++;
         infrastructure[infraRow].role = "DR (2ndRegion) [PilotLight]";
         // infrastructure[infraRow].row = infrastructure[infraRow].row + "-2";
         // console.log("origRow2", origRow, infrastructure[origRow].UsageUnits_target);
         infrastructure[infraRow].UsageUnits_target = Math.round(infrastructure[origRow].UsageUnits_target * 0.2 * 10) / 10;
         infrastructure[infraRow].Usage_comments += "Sizing Usage at 20% of Primary. ";
         
         //now add DR-MAZ
         infrastructure.push( JSON.parse(JSON.stringify(infrastructure[infraRow])) );
         infraRow++;
         infrastructure[infraRow].role = "DR-MAZ (2ndRegion) [PilotLight]";

         
       }
       
       
       infraRow++;
  }  
  
  for (var infraRow=0; infraRow< infrastructure.length ; infraRow++) {
       
       // details on X11 and X9 are here: https://docs.oracle.com/en/engineered-systems/exadata-cloud-service/ecscm/exa-service-desc.html#GUID-43F48F95-3107-4983-AB29-D95A54A01152
       // changes (create new variable/constants)
       // OCPUs to ECPUs
       // 126 to 760 UsageUnits_per_db_server
       // 63.3 to 80 tbs_per_storage_server
       // 45000 to 100000 flash_throughput_per_storage_server
       var UsageUnits_per_db_server = 126;
       var tbs_per_storage_server = 63.3;
       var flash_throughput_per_storage_server = 45000;
       var memory_per_db_server = 1390;
       
       if (infrastructure[infraRow].model=="X11M") {
            UsageUnits_per_db_server = 760;
            tbs_per_storage_server = 80;
            flash_throughput_per_storage_server = 100000;
       }
       
       // how many database servers
       var dbservers = 2;
       var reservedUnits = 0;
       infrastructure[infraRow].UsageUnits_provisioned=infrastructure[infraRow].UsageUnits_target;
       if (infrastructure[infraRow].frozen_prefs.odbAWS_service == "adb") {

          // Per Jeremy, ADB-D is capped at 20GB Memory per core, which is 5GB per ECPU
          // documented: https://docs.oracle.com/en/cloud/paas/autonomous-database/dedicated/pfcno/index.html#articletitle
          // "The default values for Database memory per ECPU (GB) and Database storage (TB) are set to 5GB and 5TB, respectively. However, you can set the Database memory per ECPU to be within a range of 2-5GB."
          // So, if the memory_target>5*#_of_ecpus, then we should increase the # of ecpus and put a message
          if (infrastructure[infraRow].Memory_target*1>5*infrastructure[infraRow].UsageUnits_target) {
              var newTarget = Math.ceil(infrastructure[infraRow].Memory_target/5);
               infrastructure[infraRow].Usage_comments += "Autonomous Database can support at most 5GB of Memory per ECPU.  The Memory target value is " + infrastructure[infraRow].Memory_target + "GB.  Therefore, increasing target ECPUs from " + infrastructure[infraRow].UsageUnits_target +" to " + newTarget + ". ";
               infrastructure[infraRow].UsageUnits_target=newTarget;
               infrastructure[infraRow].UsageUnits_provisioned=infrastructure[infraRow].UsageUnits_target;
          }
           
           // minimum 40 provisioned ECPUs per dbserver
           if (infrastructure[infraRow].UsageUnits_target<40*dbservers) {
               infrastructure[infraRow].UsageUnits_provisioned=40*dbservers;
               infrastructure[infraRow].Usage_comments += "Autonomous Database needs to provision a minimum of 40 ECPUs per database server.  Increasing provisioned ECPUs from " + infrastructure[infraRow].UsageUnits_target +" to " + infrastructure[infraRow].UsageUnits_provisioned + ". ";
           }
         
          ////ADB has 40GB of overhead per node.  https://docs.oracle.com/en/cloud/paas/autonomous-database/dedicated/adbay/#GUID-B1EC563A-CF6B-473C-A0EA-4B895DA0A319 
          memory_per_db_server = memory_per_db_server-40;
          
          // not implemented.. Free Developer Database
          // https://docs.oracle.com/en/cloud/paas/autonomous-database/dedicated/aadvv/#GUID-6B6A8567-3C77-4C96-BFEA-0945ADE1826E 
          // Autonomous Database for Developers comes fixed at 4 ECPUs and 32GB storage, and do not support manual or auto-scaling.
          

          // account for NodeFailoverReservation

          if (infrastructure[infraRow].frozen_prefs.odbAWS_adb_nodereserve=="50") {
              reservedUnits = Math.ceil(  infrastructure[infraRow].UsageUnits_provisioned * 0.5);
              infrastructure[infraRow].Usage_comments += "Reserving an extra provisioned 50% (" + reservedUnits + " " + infrastructure[infraRow].Usage_units +") for Node Failover Reservations. ";
          }
          if (infrastructure[infraRow].frozen_prefs.odbAWS_adb_nodereserve=="25") {
              reservedUnits = Math.ceil(  infrastructure[infraRow].UsageUnits_provisioned * 0.25);
              infrastructure[infraRow].Usage_comments += "Reserving an extra provisioned 25% (" + reservedUnits + " " + infrastructure[infraRow].Usage_units +") for Node Failover Reservations. ";
          }
          
          infrastructure[infraRow].UsageUnits_provisioned = infrastructure[infraRow].UsageUnits_provisioned + reservedUnits;
       }

   
       if ( (infrastructure[infraRow].UsageUnits_provisioned) > dbservers*UsageUnits_per_db_server) {
           //x11 = 190 cores not 126 
           dbservers = Math.max(2, Math.ceil((infrastructure[infraRow].UsageUnits_provisioned)/UsageUnits_per_db_server) ); //x11 = 190
           infrastructure[infraRow].Usage_comments += "Added more db servers due to " + infrastructure[infraRow].Usage_units +" needed. ";
       }
       
       // work on memory
       if (infrastructure[infraRow].Memory_target < 30) {
           console.log("ODB@AWS: Minimum memory provisioned is 30 GB per dbserver"); 
       }
       
       if ( (infrastructure[infraRow].frozen_prefs.odbAWS_service == "adb") && (infrastructure[infraRow].Memory_target < 120) ) {
           // console.log("ODB@AWS: ADB Minimum memory provisioned is 120 GB per dbserver"); // 120GB with Autonomous
           // https://docs.oracle.com/en/cloud/paas/autonomous-database/dedicated/adbay/#GUID-455E7345-2BB6-4687-8251-88545F64CFC8
           
           infrastructure[infraRow].Memory_comments += "ADB-D needs to provision a minimum of 120 GB per dbserver (original Memory minimum target value was " + infrastructure[infraRow].Memory_target + "GB). ";
           infrastructure[infraRow].Memory_target = 120 * dbservers;
       }
       
       
       if (infrastructure[infraRow].Memory_target > dbservers*memory_per_db_server) {
           dbservers = Math.max(dbservers, Math.ceil(infrastructure[infraRow].Memory_target/memory_per_db_server) );
           // console.log("adding more db servers due to Memory", infrastructure[infraRow].Memory_target, dbservers);
           infrastructure[infraRow].Usage_comments += "Added more db servers due to memory needed. ";
       }
       infrastructure[infraRow].dbservers = dbservers;
       
       // "Use multiples of two OCPUs per database server or multiples of 8 ECPUS per X11M database server. "
       // https://docs.oracle.com/en/engineered-systems/exadata-cloud-service/ecscm/ecs-manage-infrastructure.html#GUID-31F6EEEF-43FD-46D6-9DCF-04784CC77AE8 
       /*
       https://docs.oracle.com/en/engineered-systems/exadata-cloud-service/ecscm/ecs-manage-infrastructure.html#GUID-31F6EEEF-43FD-46D6-9DCF-04784CC77AE8 says "Use multiples of two CPUs per database server or multiples of 8 ECPUS per X11M database server."

       https://docs.oracle.com/en/engineered-systems/exadata-cloud-service/ecscm/exa-service-desc.html#GUID-2BFEF2B5-A66B-4F9C-BD3B-3B346B95EBE5 says "In the case of X11M, if you have 6 database servers provisioned, you can add ECPUs in multiples of 24." (which is effectively saying multiples of 4 ECPUs per X11M database server)
       
       Discussed internally at https://amzn-aws.slack.com/archives/C07LM7DRGL8/p1770905269040109
       Takeaway: the minimum is 8 ECPUs per DB server.  THen you can scale in QTY 4 ECPUs per server.
       */
       var scaleQty = 1;
       var minQty = 2;
       if (infrastructure[infraRow].model=="X11M") {
           scaleQty=4;
           minQty=8;
       }
       var orig_provisioned =  infrastructure[infraRow].UsageUnits_provisioned;
       infrastructure[infraRow].UsageUnits_provisioned = Math.ceil(Math.max(orig_provisioned, minQty) / scaleQty / infrastructure[infraRow].dbservers) * scaleQty * infrastructure[infraRow].dbservers ;
       infrastructure[infraRow].UsageUnits_available = infrastructure[infraRow].dbservers * UsageUnits_per_db_server;  
       
       if (orig_provisioned != infrastructure[infraRow].UsageUnits_provisioned) {
         infrastructure[infraRow].Usage_comments += infrastructure[infraRow].Usage_units +" provisioned rounded up from "+ orig_provisioned + " to " + infrastructure[infraRow].UsageUnits_provisioned;
       }
       
       infrastructure[infraRow].Memory_available = infrastructure[infraRow].dbservers * memory_per_db_server;
       
       if (infrastructure[infraRow].frozen_prefs.odbAWS_service == "adb") {
          // console.log("calculated Database Memory per unit", Math.round(infrastructure[infraRow].Memory_target / infrastructure[infraRow].UsageUnits_provisioned));
       }       
       
       
       // for ADB, should I adjust the storage needed?  Not yet implemented.
       // Exadata Storage = [User Data Storage + Internal Database Service Storage: ( 200GB + 50GB x ACD Count x Node Count )] x 1.25
       // https://docs.oracle.com/en/cloud/paas/autonomous-database/dedicated/adbay/#GUID-B1EC563A-CF6B-473C-A0EA-4B895DA0A319 

       
       // how many storage servers
       var storageservers = 3;
       // single storage server has 63.3 TB of usable. x11 has 80TB
       
       // storageStyles - https://docs.oracle.com/en/engineered-systems/exadata-cloud-service/ecscm/ecs-storage-config.html#GUID-925DAEBF-4693-4AC6-80E1-15D7121F80A9
       // if storagestyle==default, 80%
       // if backup=y,sparse=n, 40%
       // if backup=n,sparse=y, 60%
       // if backup=y,sparse=y, 35%
       
       var data_disk_group_percent=0.8;
       var reco_disk_group_percent=0.2;
       
       if (infrastructure[infraRow].frozen_prefs.odbAWS_StorageStyle == "BACKUP") {
           data_disk_group_percent=0.4;
           reco_disk_group_percent=0.6;
       }
       if (infrastructure[infraRow].frozen_prefs.odbAWS_StorageStyle == "SPARSE") {
           data_disk_group_percent=0.6;
           reco_disk_group_percent=0.2;
       }
       if (infrastructure[infraRow].frozen_prefs.odbAWS_StorageStyle == "BOTH") {
           data_disk_group_percent=0.35;
           reco_disk_group_percent=0.5;
       }
       
       if ( (infrastructure[infraRow].frozen_prefs.odbAWS_service=="adb") &&  (infrastructure[infraRow].frozen_prefs.odbAWS_StorageStyle != "BACKUP") ) {
           if ( (infrastructure[infraRow].frozen_prefs.odbAWS_HA!="single") || (infrastructure[infraRow].frozen_prefs.odbAWS_DR!="N") ) {
             // infrastructure[infraRow].storage_comments += "Switching storage allocation to store backups as that is required by Autonomous Data Guard (used by MAA and DR topologies). ";
             // data_disk_group_percent=0.4;
             // reco_disk_group_percent=0.6;
             // infrastructure[infraRow].frozen_prefs.odbAWS_StorageStyle = "BACKUP";
             console.log("Disabled check: Switching storage allocation to store backups as that is required by Autonomous Data Guard (used by MAA and DR topologies). ");
           }
       }
       infrastructure[infraRow].storage_style = infrastructure[infraRow].frozen_prefs.odbAWS_StorageStyle;
       
       var totalspaceneeded = infrastructure[infraRow].storage_target / data_disk_group_percent;
       if (totalspaceneeded > storageservers*tbs_per_storage_server * 1000) { // x11=80
           storageservers = Math.max(3, Math.ceil(totalspaceneeded/tbs_per_storage_server / 1000) ); // x11=80
           // console.log("adding more storage servers due to space needed", infrastructure[infraRow].storage_target, data_disk_group_percent, totalspaceneeded, storageservers);
           infrastructure[infraRow].storage_comments += "Added more storage servers due to space needed. ";
       }
       
       // now check Throughput
       // May be 45 GB/s for x9.  See https://www.oracle.com/a/ocom/docs/database/auto-db-dedicated-exadata-infra-ds.pdf 
       // may be 100 GB/s for x11 (flash bandwidth per storage server)
       
       if ( (flash_throughput_per_storage_server * storageservers) < infrastructure[infraRow].Throughput_target*1 ) { // x11 is 100000
           storageservers = Math.max(3, Math.ceil(infrastructure[infraRow].Throughput_target/flash_throughput_per_storage_server) ); // x11 is 100000
           // console.log("adding more storage servers due to Throughput needed", infrastructure[infraRow].Throughput_target, storageservers);
           infrastructure[infraRow].storage_comments += "Added more storage servers due to Throughput needed. ";
       }
       infrastructure[infraRow].storageservers = storageservers;
       
       // infrastructure[infraRow].storage_comments += "Target DATA disk group is "+infrastructure[infraRow].storage_target + " GB." +
        //  "  DATA disk group will be allocated " + Math.round(100*data_disk_group_percent) + "% of storage.  Total storage (all disk groups) is "+
        //  Math.round(storageservers*tbs_per_storage_server*1000) + "GB.";
          
       infrastructure[infraRow].storage_total_available =  Math.round(storageservers*tbs_per_storage_server  );      //x11=90
       infrastructure[infraRow].storage_data_dg =  Math.round(storageservers*tbs_per_storage_server * data_disk_group_percent );
       infrastructure[infraRow].storage_reco_dg =  Math.round(storageservers*tbs_per_storage_server * reco_disk_group_percent);
       infrastructure[infraRow].storage_sparse_dg = Math.round(storageservers*tbs_per_storage_server * (1-data_disk_group_percent-reco_disk_group_percent)) ;
       
       
  }   
    return infrastructure;   
  
}  




function   calculate_exadata_config(regionInfo, databases) {

   var exaTargets = aggregate_database_targets(databases);
        // console.log("calculate_exadata_config- exaTargets", exaTargets);
    // TODO: what about multiple scenarioNames?  exaTargets should be an array keyed by scenarioName    
        
    var infrastructure = pick_exadata_shape(exaTargets);
        // console.log("calculate_exadata_config- infrastructure (post pick shape)", infrastructure);


  for (var groupi=0; groupi< infrastructure.length ; groupi++) {
    
         // according to price list: https://www.oracle.com/cloud/price-list/#exadata, quarter rack is $14.5162/hour, but servr is $2.9032.hour.
     // that means that infrastructure is $10800.0528, not 10799.904.  A difference of 0.1488. Or 0.02976 per server.
     // so we will add 2*0.02976 to the base db_server cost and 3*0.02976 to the storage_cost to match Oracle cost calculator
     // this is only for X9M
     var cost_fix=0.02976;
     if (infrastructure[groupi].model=="X11M") {
         cost_fix=0;
     }
     // infrastructure[groupi].dbserver_cost = Math.round(infrastructure[groupi].dbservers * 2.9032 * 744 *100 + 2*cost_fix*100)/100; //regionInfo.odbDBSERVER
     // infrastructure[groupi].storage_cost = Math.round(infrastructure[groupi].storageservers * 2.9032 * 744 *100 + 3*cost_fix*100)/100; //regionInfo.odbSTORAGESERVER
     
     // July1 - new pricing.
     // https://www.oracle.com/cloud/price-list/#pricing-oracle-databases
     // database server is $6.3014 per hour. was $2.9032
     // storage server is $5.4795 per hour. was $2.9032
     infrastructure[groupi].dbserver_cost = Math.round(infrastructure[groupi].dbservers * 6.3014 * 744 *100 + 2*cost_fix*100)/100; //regionInfo.odbDBSERVER
     infrastructure[groupi].storage_cost = Math.round(infrastructure[groupi].storageservers * 5.4795 * 744 *100 + 3*cost_fix*100)/100; //regionInfo.odbSTORAGESERVER
     
     // ECPU FAQ: https://www.oracle.com/a/ocom/docs/autonomous-database-ecpu-faq.pdf
     // Convert OCPUs to ECPUs based on cost.
     // Autonomous is priced the same as ExaCS? $0.3226 per OCPU?
     var BYOL_cost = 0.3226;
     var LI_cost=1.3441;
     if (infrastructure[groupi].model=="X11M") {
         BYOL_cost = 0.0807;
         LI_cost = 0.336;
     }
     
     // for ExaDB, use UsageUnit_provisioned.  For ADB, use Usage_target for billing.
     var Usage_billing = infrastructure[groupi].UsageUnits_provisioned;
     if (infrastructure[groupi].frozen_prefs.odbAWS_service == "adb") {
        Usage_billing = infrastructure[groupi].UsageUnits_target;
     }       
     infrastructure[groupi].UsageUnits_billed = Usage_billing;
            
     if (infrastructure[groupi].frozen_prefs.odbAWS_Licensing=="BYOL") {
       infrastructure[groupi].Usage_cost = Math.round(Usage_billing * BYOL_cost * 744 *100)/100; //regionInfo.odbOCPUBYOL
       infrastructure[groupi].licenseType = "BYOL";
       infrastructure[groupi].licenseText = "BYOL " + infrastructure[groupi].Usage_units + " Usage for "+ Usage_billing+ " " + infrastructure[groupi].Usage_units + "s";
     } else {
       infrastructure[groupi].Usage_cost = Math.round(Usage_billing * LI_cost * 744 *100)/100; //regionInfo.odbOCPULI
       infrastructure[groupi].licenseType = "LI";
       infrastructure[groupi].licenseText = "License Included " + infrastructure[groupi].Usage_units + " Usage for "+ Usage_billing+ " " + infrastructure[groupi].Usage_units + "s";
     } 
     infrastructure[groupi].monthly_estimate = Math.round( (infrastructure[groupi].dbserver_cost + infrastructure[groupi].storage_cost + infrastructure[groupi].Usage_cost) *100)/100;
     infrastructure[groupi].specificationText = "Exadata " + infrastructure[groupi].model + " Dedicated Infrastructure (" + infrastructure[groupi].dbservers + " db servers and " +
         infrastructure[groupi].storageservers + " storage servers with " +
         infrastructure[groupi].licenseType+ " usage for " + Usage_billing + " " + infrastructure[groupi].Usage_units + "s)";
         
     infrastructure[groupi].summaryText = infrastructure[groupi].specificationText + " = $" +
         infrastructure[groupi].monthly_estimate + " per month";
         
     infrastructure[groupi].summaryText = infrastructure[groupi].summaryText + ".  (Infrastructure=$" + Math.round( (infrastructure[groupi].dbserver_cost + infrastructure[groupi].storage_cost ) *100)/100 +
         " " + infrastructure[groupi].Usage_units + "s=$" + Math.round( ( infrastructure[groupi].Usage_cost ) *100)/100 + ")";
         
       
  }
        
        // console.log("calculate_exadata_config- infrastructure (post pricing)", infrastructure);
    return infrastructure;
}






function calculate_adbs_config(regionInfo, config) {
    
  let ecpu_warnings = ""; 
  
  // Use OrigMemory if it exists and differs from Memory
  let working_Memory = config.Memory;
  if ((config.OrigMemory != undefined) && (config.Memory != config.OrigMemory)) {
    working_Memory = config.OrigMemory;
  }

  // Use OrigVCPU if it exists and differs from VCPU
  let working_VCPU = config.VCPU;
  if ((config.OrigVCPU != undefined) && (config.VCPU != config.OrigVCPU)) {
    working_VCPU = config.OrigVCPU;
    
  }
  
  if ( (working_VCPU = config.VCPU) || (working_Memory = config.Memory) ) {
    ecpu_warnings += `Using original Exadata VCPU (${working_VCPU}) and Memory (${working_Memory}) values for ADB-S calculations. `;  
  }
  
  
  // Use OrigThroughput if it exists and differs from Throughput
  let working_Throughput = config.Throughput;
  if ((config.OrigThroughput != undefined) && (config.Throughput != config.OrigThroughput)) {
    working_Throughput = config.OrigThroughput;
  }
  
  const ecpu_requested = working_VCPU * 2;
  let ecpu_billed = Math.max(2, Math.ceil(ecpu_requested));
  let storage_billed = config.DiskSpace;
  
  let storage_warnings = "";
  let exceeds_limits = false;
  
  // Check memory-to-ECPU ratio: at least 1 ECPU for every 3 GB of memory
  const min_ecpu_for_memory = Math.ceil(working_Memory / 3);
  if (ecpu_billed < min_ecpu_for_memory) {
    ecpu_warnings += `ECPU increased from ${ecpu_billed} to ${min_ecpu_for_memory} to meet memory-to-ECPU ratio guideline (1 ECPU per 3 GB). `;
    ecpu_billed = min_ecpu_for_memory;
  }
  
  if (ecpu_billed > 512) {
    ecpu_warnings += "ECPU exceeds maximum of 512. Cannot size for ADBS. ";
    exceeds_limits = true;
  } else if (ecpu_billed > ecpu_requested) {
    ecpu_warnings += "ECPU rounded up to minimum or nearest integer. ";
  }
  
  const max_storage_gb = 384 * 1024;
  if (storage_billed > max_storage_gb) {
    storage_warnings = `Storage exceeds maximum of 384TB. Cannot size for ADBS.`;
    exceeds_limits = true;
  }
  
  // If limits exceeded, set costs to null
  if (exceeds_limits) {
    config.targetconfig_adbs = {
      shape: "N/A",    
      summaryText: "DBCSI's current logic is not able to auto-size this configuration for ADBS. Exceeds maximum limits.",
      monthly_estimate: null,
      ecpu_requested: ecpu_requested,
      ecpu_billed: null,
      storage_billed: null,
      storage_requested: config.DiskSpace,
      ecpu_cost: null,
      storage_cost: null,
      ecpu_warnings: ecpu_warnings,
      storage_warnings: storage_warnings,
      adbs_type: "atp",
      license_type: config.frozen_prefs.odbAWS_Licensing
    };
    return config;
  }
  
  // Determine if Local Peer should be added
  let addLocalPeer = false;
  if (config.frozen_prefs.odbAWS_HA === 'Y') {
    addLocalPeer = true;
  } else if (config.frozen_prefs.odbAWS_HA === 'UseMAZ' && config.UseMAZ === 'Yes') {
    addLocalPeer = true;
  }
  
  // Determine if Cross-Region Peer should be added
  const addCrossRegionPeer = config.frozen_prefs.odbAWS_DR === 'Y';
  
  // Calculate costs
  // Local Peer doubles both ECPU and storage
  const localPeerMultiplier = addLocalPeer ? 2 : 1;
  // Cross-Region Peer adds 1x ECPU and 2x storage
  const ecpu_rate = config.frozen_prefs.odbAWS_Licensing === 'BYOL' ? 0.0807 : 0.336;
  const total_ecpu_billed = ecpu_billed * localPeerMultiplier + (addCrossRegionPeer ? ecpu_billed : 0);
  const total_storage_billed = storage_billed * localPeerMultiplier + (addCrossRegionPeer ? storage_billed * 2 : 0);
  
  const ecpu_cost = Math.round(total_ecpu_billed * ecpu_rate * 744 * 100) / 100;
  
  // new pricing as of July 1 2026
  // storage is $0.1953/GB.  Was $0.1156
  // const storage_cost = Math.round(total_storage_billed * 0.1156 * 100) / 100;
  const storage_cost = Math.round(total_storage_billed * 0.1953 * 100) / 100;  
  const monthly_estimate = Math.round((ecpu_cost + storage_cost) * 100) / 100;

  let peerText = "";
  let shortPeerText = "";
  if (addLocalPeer && addCrossRegionPeer) {
    peerText = " with Local Peer and Cross-Region Peer for DR (Autonomous Data Guard)";
    shortPeerText = " + Local Peer and Cross-Region Peer";
  } else if (addLocalPeer) {
    peerText = " with Local Peer (Autonomous Data Guard)";
    shortPeerText = " + Local Peer";
  } else if (addCrossRegionPeer) {
    peerText = " with Cross-Region Peer for DR (Autonomous Data Guard)";
    shortPeerText = " + Cross-Region Peer";
  }
  
  const ecpuText = ecpu_billed !== total_ecpu_billed ? `${ecpu_billed} ECPUs (${total_ecpu_billed} when accounting for peers)` : `${ecpu_billed} ECPUs`;
  const storageText = storage_billed !== total_storage_billed ? `${storage_billed} GB storage (${total_storage_billed} GB when accounting for peers)` : `${storage_billed} GB storage`;
  
  config.targetconfig_adbs = {
    shape: `Autonomous Serverless: ${ecpu_billed} ECPUs, ${storage_billed} GB storage${shortPeerText}`,  
    summaryText: `Autonomous Database Serverless (ATP) with ${ecpuText} and ${storageText}${peerText} ${config.frozen_prefs.odbAWS_Licensing === 'BYOL' ? 'BYOL' : 'License Included'} = $${monthly_estimate} per month`,
    monthly_estimate: monthly_estimate,
    ecpu_requested: ecpu_requested,
    ecpu_billed: total_ecpu_billed,
    storage_requested: config.DiskSpace,
    storage_billed: total_storage_billed,
    ecpu_cost: ecpu_cost,
    storage_cost: storage_cost,
    ecpu_warnings: ecpu_warnings,
    storage_warnings: storage_warnings,
    adbs_type: "atp",
    license_type: config.frozen_prefs.odbAWS_Licensing,
    UseMAZ: addLocalPeer ? 'Yes' : 'No'
  };

  return config;
}




function   pick_exascale_shape(exaTargets) {

    // ExaScale (ExaDB-XS) is fundamentally different from ExaDB-D (Dedicated Infrastructure).
    // Instead of DB servers + storage servers, we provision:
    //   - Number of VMs (1-10, typically min 2 for HA)
    //   - ECPUs per VM (8-200, multiples of 4)
    //   - VM Filesystem storage per VM (min 280 GB)
    //   - Database Storage in a shared Exascale Storage Vault (300-100,000 GB)
    //   - Additional Flash Cache (optional, 0 by default)
    // Memory is auto-calculated: 2.75 GB per ECPU (not independently provisionable)

  var infrastructure = [];    
  var infraRow = 0;

  for (var scen=0; scen< exaTargets.length ; scen++) {

      // Only process ExaScale scenarios
      if (exaTargets[scen].frozen_prefs.odbAWS_service != "exascale") { continue; }
  
      infrastructure.push ( 
       {
        row: "("+exaTargets[scen].scenarioName+")",
        model: "ExaScale",
        service: "exadb-xs",
        role: "Primary",
        num_vms: 2,
        ecpus_per_vm: 8,
        ecpus_enabled_total: 16,
        ecpus_reserved_per_vm: 0,
        ecpus_reserved_total: 0,
        memory_per_vm_gb: 22,
        memory_total_gb: 44,
        vm_filesystem_per_vm_gb: 280,
        vm_filesystem_total_gb: 560,
        database_storage_gb: 300,
        additional_flash_cache_gb: 0,
        Usage_units: "ECPU",
        Usage_comments: "",
        Memory_comments: "",
        assumptionsString: exaTargets[scen].assumptionsString,
        assumptionsArray: exaTargets[scen].assumptionsArray,
        storage_comments: "",
        databases: [],
        scenarioName: exaTargets[scen].scenarioName,
        manual: "NO"
       }
      );
      
      var row = infrastructure[infraRow];
      
      // Step 1: Convert VCPU targets to ECPUs
      // Same conversion as X11M: VCPU / 2 = OCPU, OCPU * 4 = ECPU
      var ecpu_target = Math.round( exaTargets[scen].VCPU_total / 2 * 4 * 100) / 100;
      row.Usage_comments += "Converted " + Math.round(exaTargets[scen].VCPU_total * 100) / 100 + " VCPUs into " + ecpu_target + " ECPUs. ";
      
      // Step 2: Check if memory requires more ECPUs for RDMA reservation
      // Memory = 2.75 GB per ECPU, so required ECPUs for memory = memory_target / 2.75
      // The memory bump only applies to the reserved (RDMA) quantity, not the enabled (usage) quantity
      var memory_target = exaTargets[scen].Memory_total;
      var ecpus_for_memory = Math.ceil(memory_target / 2.75);
      
      var ecpu_reserved_target = ecpu_target;
      if (ecpus_for_memory > ecpu_target) {
          row.Usage_comments += "Memory target (" + memory_target + " GB) requires " + ecpus_for_memory + " ECPUs (at 2.75 GB/ECPU). Increasing ECPU reserved target from " + ecpu_target + " to " + ecpus_for_memory + " (usage target remains at " + ecpu_target + "). ";
          ecpu_reserved_target = ecpus_for_memory;
      }
      
      // Step 3: Determine number of VMs needed
      // Default based on multiAZ_algo: N=1 VM, Y=2 VMs, auto=2 if RAC source else 1
      // Each VM can have at most 200 ECPUs, max 10 VMs
      var num_vms = 2;
      if (exaTargets[scen].frozen_prefs.multiAZ_algo == "N") {
          num_vms = 1;
      } else if (exaTargets[scen].frozen_prefs.multiAZ_algo == "auto") {
          if (exaTargets[scen].hasRAC) {
              num_vms = 2;
          } else {
              num_vms = 1;
          }
      }
      // multiAZ_algo == "Y" keeps num_vms = 2
      
      var ecpus_per_vm = Math.ceil(ecpu_target / num_vms);
      
      if (ecpus_per_vm > 200) {
          num_vms = Math.min(10, Math.ceil(ecpu_target / 200));
          ecpus_per_vm = Math.ceil(ecpu_target / num_vms);
          row.Usage_comments += "Increased VMs to " + num_vms + " to stay within 200 ECPUs/VM limit. ";
      }
      
      // Step 4: Round ECPUs per VM up to nearest multiple of 4, minimum 8
      ecpus_per_vm = Math.max(8, Math.ceil(ecpus_per_vm / 4) * 4);
      
      // Cap at 200
      if (ecpus_per_vm > 200) {
          ecpus_per_vm = 200;
      }
      
      // Step 4b: Calculate reserved ECPUs per VM (may be higher than enabled due to memory needs)
      var ecpus_reserved_per_vm = Math.ceil(ecpu_reserved_target / num_vms);
      ecpus_reserved_per_vm = Math.max(8, Math.ceil(ecpus_reserved_per_vm / 4) * 4);
      if (ecpus_reserved_per_vm > 200) {
          ecpus_reserved_per_vm = 200;
      }
      // Reserved must be >= enabled
      if (ecpus_reserved_per_vm < ecpus_per_vm) {
          ecpus_reserved_per_vm = ecpus_per_vm;
      }
      
      // Step 5: Calculate memory (auto-derived from reserved ECPUs, since memory is tied to reservation)
      var memory_per_vm = ecpus_reserved_per_vm * 2.75;
      var memory_total = memory_per_vm * num_vms;
      
      if (memory_total < memory_target) {
          // Add more VMs to satisfy the memory target
          var ecpus_needed_for_memory = Math.ceil(memory_target / 2.75);
          var new_num_vms = Math.min(10, Math.ceil(ecpus_needed_for_memory / 200));
          if (new_num_vms < 2) new_num_vms = 2; // need at least enough VMs
          // Ensure we actually have enough with this many VMs
          while (new_num_vms <= 10) {
              var test_reserved_per_vm = Math.ceil(ecpus_needed_for_memory / new_num_vms);
              test_reserved_per_vm = Math.max(8, Math.ceil(test_reserved_per_vm / 4) * 4);
              if (test_reserved_per_vm <= 200) break;
              new_num_vms++;
          }
          if (new_num_vms > num_vms) {
              num_vms = new_num_vms;
              // Recalculate enabled ECPUs per VM with new num_vms
              ecpus_per_vm = Math.ceil(ecpu_target / num_vms);
              ecpus_per_vm = Math.max(8, Math.ceil(ecpus_per_vm / 4) * 4);
              if (ecpus_per_vm > 200) ecpus_per_vm = 200;
              // Recalculate reserved ECPUs per VM with new num_vms
              ecpus_reserved_per_vm = Math.ceil(ecpus_needed_for_memory / num_vms);
              ecpus_reserved_per_vm = Math.max(8, Math.ceil(ecpus_reserved_per_vm / 4) * 4);
              if (ecpus_reserved_per_vm > 200) ecpus_reserved_per_vm = 200;
              if (ecpus_reserved_per_vm < ecpus_per_vm) ecpus_reserved_per_vm = ecpus_per_vm;
              // Recalculate memory
              memory_per_vm = ecpus_reserved_per_vm * 2.75;
              memory_total = memory_per_vm * num_vms;
              row.Memory_comments += "Note: Added additional VMs to satisfy the memory target (" + Math.round(memory_target) + " GB) based on needing 1 ECPU for every 2.75GB of memory. ";
              // If the new enabled ECPUs total is forced up to the minimum (8 ECPUs per VM)
              var new_enabled_total = ecpus_per_vm * num_vms;
              if (new_enabled_total > ecpu_target && new_enabled_total == 8 * num_vms) {
                  row.Usage_comments += "Increasing the Target Usage ECPUs to " + new_enabled_total + " because each VM requires a minimum of 8 ECPUs. ";
              }
          }
      }
      
      // Now that all VM count adjustments are finalized, add single-node comment if applicable
      if (num_vms == 1) {
          row.Usage_comments += "Single-node VM cluster. Consider RAC or Data Guard for availability. ";
      }
      
      // Step 6: VM Filesystem storage
      // Minimum 280 GB per VM. Extra goes to /u02 for DB homes.
      // For now, default to 280 GB. Could be made configurable.
      var vm_filesystem_per_vm = 280;
      
      // Step 7: Database storage (Exascale Storage Vault)
      // Minimum 300 GB, maximum 100,000 GB
      var database_storage = Math.max(300, Math.ceil(exaTargets[scen].storage_total));
      if (database_storage > 100000) {
          row.storage_comments += "Warning: Storage target (" + database_storage + " GB) exceeds maximum vault size of 100,000 GB. Capping at 100,000 GB. ";
          database_storage = 100000;
      }
      if (exaTargets[scen].storage_total < 300) {
          row.storage_comments += "Storage target (" + Math.round(exaTargets[scen].storage_total) + " GB) is below minimum of 300 GB. Using minimum 300 GB. ";
      }
      
      // Step 8: Additional Flash Cache
      // For now, hardcoded to 0. Future logic could add flash cache based on IOPS/Throughput metrics.
      var additional_flash_cache = 0;
      // TODO: potential future logic:
      // if (exaTargets[scen].IOPS_total > some_threshold) { additional_flash_cache = some_calculation; }
      // if (exaTargets[scen].Throughput_total > some_threshold) { additional_flash_cache = some_calculation; }
      // Flash cache must be at least 100 GB if enabled, and specified as 34%-300% of database_storage
      
      // Set final values
      row.num_vms = num_vms;
      row.ecpus_per_vm = ecpus_per_vm;
      row.ecpus_enabled_total = ecpus_per_vm * num_vms;
      row.ecpus_reserved_per_vm = ecpus_reserved_per_vm;
      row.ecpus_reserved_total = ecpus_reserved_per_vm * num_vms;
      row.memory_per_vm_gb = Math.round(memory_per_vm * 100) / 100;
      row.memory_total_gb = Math.round(memory_total * 100) / 100;
      row.vm_filesystem_per_vm_gb = vm_filesystem_per_vm;
      row.vm_filesystem_total_gb = vm_filesystem_per_vm * num_vms;
      row.database_storage_gb = database_storage;
      row.additional_flash_cache_gb = additional_flash_cache;
      
      // Carry forward targets for reference
      row.VCPU_total = exaTargets[scen].VCPU_total;
      row.Memory_target = memory_target;
      row.IOPS_target = exaTargets[scen].IOPS_total;
      row.Throughput_target = exaTargets[scen].Throughput_total;
      row.storage_target = exaTargets[scen].storage_total;
      row.frozen_prefs = exaTargets[scen].frozen_prefs;
      
      
      // Handle HA (MAZ) and DR - duplicate rows just like pick_exadata_shape
      var origRow = infraRow;
      
      if ( (row.frozen_prefs.odbAWS_HA == "Y") ) {
        row.multiAZ = "Yes";  
        infrastructure.push( JSON.parse(JSON.stringify(row)) );
        infraRow++;
        infrastructure[infraRow].role = "Standby(MAZ)";
        
      } else if (row.frozen_prefs.odbAWS_HA == "Y20") {
        row.multiAZ = "Yes";  
        infrastructure.push( JSON.parse(JSON.stringify(row)) );
        infraRow++;
        infrastructure[infraRow].role = "Standby-MAZ [PilotLight]";
        // For pilot light, reduce enabled ECPUs to 20% but respect minimums
        // Reserved ECPUs (RDMA) stay the same as primary — memory is tied to reservation
        var pilotEcpu = Math.max(8, Math.ceil(row.ecpus_per_vm * 0.2 / 4) * 4);
        infrastructure[infraRow].ecpus_per_vm = pilotEcpu;
        infrastructure[infraRow].ecpus_enabled_total = pilotEcpu * num_vms;
        infrastructure[infraRow].Usage_comments += "Sizing enabled ECPUs at 20% of Primary. Reserved ECPUs unchanged. ";
      }

      // DR handling
      if ( (row.frozen_prefs.odbAWS_DR == "Y") ) {
        row.DR = "Yes";  
        infrastructure.push( JSON.parse(JSON.stringify(infrastructure[origRow])) );
        infraRow++;
        infrastructure[infraRow].role = "DR (2ndRegion)";
        
      } else if (row.frozen_prefs.odbAWS_DR == "Y20") {
        row.DR = "Yes";  
        infrastructure.push( JSON.parse(JSON.stringify(infrastructure[origRow])) );
        infraRow++;
        infrastructure[infraRow].role = "DR (2ndRegion) [PilotLight]";
        var pilotEcpuDR = Math.max(8, Math.ceil(infrastructure[origRow].ecpus_per_vm * 0.2 / 4) * 4);
        infrastructure[infraRow].ecpus_per_vm = pilotEcpuDR;
        infrastructure[infraRow].ecpus_enabled_total = pilotEcpuDR * num_vms;
        infrastructure[infraRow].Usage_comments += "Sizing enabled ECPUs at 20% of Primary. Reserved ECPUs unchanged. ";

      } else if ( (row.frozen_prefs.odbAWS_DR == "YMA") ) {
        row.DR = "Yes";  
        infrastructure.push( JSON.parse(JSON.stringify(infrastructure[origRow])) );
        infraRow++;
        infrastructure[infraRow].role = "DR (2ndRegion)";
        
        // DR-MAZ
        infrastructure.push( JSON.parse(JSON.stringify(infrastructure[infraRow])) );
        infraRow++;
        if (row.frozen_prefs.odbAWS_HA == "Y20") {
          infrastructure[infraRow].role = "DR-MAZ (2ndRegion) [PilotLight]";
          var pilotEcpuDRMAZ = Math.max(8, Math.ceil(infrastructure[origRow].ecpus_per_vm * 0.2 / 4) * 4);
          infrastructure[infraRow].ecpus_per_vm = pilotEcpuDRMAZ;
          infrastructure[infraRow].ecpus_enabled_total = pilotEcpuDRMAZ * num_vms;
          infrastructure[infraRow].Usage_comments += "Sizing enabled ECPUs at 20% of Primary. Reserved ECPUs unchanged. ";
        } else {
          infrastructure[infraRow].role = "DR-MAZ (2ndRegion)";
        }

      } else if (row.frozen_prefs.odbAWS_DR == "YMA20") {
        row.DR = "Yes";  
        infrastructure.push( JSON.parse(JSON.stringify(infrastructure[origRow])) );
        infraRow++;
        infrastructure[infraRow].role = "DR (2ndRegion) [PilotLight]";
        var pilotEcpuDR2 = Math.max(8, Math.ceil(infrastructure[origRow].ecpus_per_vm * 0.2 / 4) * 4);
        infrastructure[infraRow].ecpus_per_vm = pilotEcpuDR2;
        infrastructure[infraRow].ecpus_enabled_total = pilotEcpuDR2 * num_vms;
        infrastructure[infraRow].Usage_comments += "Sizing enabled ECPUs at 20% of Primary. Reserved ECPUs unchanged. ";

        // DR-MAZ
        infrastructure.push( JSON.parse(JSON.stringify(infrastructure[infraRow])) );
        infraRow++;
        infrastructure[infraRow].role = "DR-MAZ (2ndRegion) [PilotLight]";
      }
       
      infraRow++;
  }  
  
  return infrastructure;   
}  



function   calculate_exascale_config(regionInfo, databases) {

   var exaTargets = aggregate_database_targets(databases);
    
   var infrastructure = pick_exascale_shape(exaTargets);

  // Pricing for ExaScale (ExaDB-XS)
  // 4 billing meters (5 if additional flash cache is used):
  //   1. RDMA Compute Infrastructure: $0.0375 per ECPU per hour (billed for ALL ECPUs: enabled + reserved)
  //   2. Database ECPU (License Included): $0.336 per ECPU per hour (billed for ENABLED ECPUs only)
  //   2b. Database ECPU (BYOL): $0.0807 per ECPU per hour (billed for ENABLED ECPUs only)
  //   3. Smart Database Storage: $0.1953 per GB per month
  //   4. VM Filesystem Storage: $0.0999 per GB per month
  //   5. Additional Flash Cache: $0.0009 per GB per hour (if any)
  //
  // 48-hour minimum commitment for ECPU billing.
  // Per-second billing after 48 hours, with 1-minute minimum per ECPU added.

  var RDMA_rate = 0.0375;          // per ECPU per hour
  var ECPU_LI_rate = 0.336;        // per ECPU per hour (License Included)
  var ECPU_BYOL_rate = 0.0807;     // per ECPU per hour (BYOL)
  var db_storage_rate = 0.1953;    // per GB per month
  var vm_fs_rate = 0.0999;         // per GB per month
  var flash_cache_rate = 0.0009;   // per GB per hour
  var hours_per_month = 744;

  for (var groupi=0; groupi< infrastructure.length ; groupi++) {
    
     var row = infrastructure[groupi];
     
     // Total ECPUs for RDMA billing (reserved = total provisioned capacity on VMs)
     var total_ecpus_for_rdma = row.ecpus_reserved_total;
     
     // ECPUs for database license billing (enabled only)
     var ecpus_for_license = row.ecpus_enabled_total;
     
     // 1. RDMA Compute cost
     row.rdma_cost = Math.round(total_ecpus_for_rdma * RDMA_rate * hours_per_month * 100) / 100;
     
     // 2. Database ECPU cost (License Included or BYOL)
     var ecpu_rate = ECPU_LI_rate;
     if (row.frozen_prefs.odbAWS_Licensing === "BYOL") {
         ecpu_rate = ECPU_BYOL_rate;
         row.licenseType = "BYOL";
     } else {
         row.licenseType = "LI";
     }
     row.ecpu_cost = Math.round(ecpus_for_license * ecpu_rate * hours_per_month * 100) / 100;
     
     // 3. Database Storage cost
     row.db_storage_cost = Math.round(row.database_storage_gb * db_storage_rate * 100) / 100;
     
     // 4. VM Filesystem Storage cost
     row.vm_fs_cost = Math.round(row.vm_filesystem_total_gb * vm_fs_rate * 100) / 100;
     
     // 5. Additional Flash Cache cost
     row.flash_cache_cost = Math.round(row.additional_flash_cache_gb * flash_cache_rate * hours_per_month * 100) / 100;
     
     // Total monthly estimate
     row.monthly_estimate = Math.round( (row.rdma_cost + row.ecpu_cost + row.db_storage_cost + row.vm_fs_cost + row.flash_cache_cost) * 100) / 100;
     
     // Specification and summary text
     row.licenseText = (row.licenseType === "BYOL" ? "BYOL" : "License Included") + " ECPU Usage for " + ecpus_for_license + " ECPUs";
     
     row.specificationText = "Exadata ExaScale (" + row.num_vms + " VMs x " + row.ecpus_per_vm + " ECPUs/VM enabled = " +
         row.ecpus_enabled_total + " ECPUs enabled";
     if (row.ecpus_reserved_total > row.ecpus_enabled_total) {
         row.specificationText += ", " + row.ecpus_reserved_total + " ECPUs reserved";
     }
     row.specificationText += ", " +
         row.database_storage_gb + " GB database storage, " +
         row.vm_filesystem_per_vm_gb + " GB filesystem/VM, " +
         row.licenseType + ")";
     
     if (row.additional_flash_cache_gb > 0) {
         row.specificationText += " + " + row.additional_flash_cache_gb + " GB additional flash cache";
     }
         
     row.summaryText = row.specificationText + " = $" + row.monthly_estimate + " per month";
     
     row.summaryText += ".  (RDMACompute(" + row.ecpus_reserved_total + " ECPUs)=$" + row.rdma_cost +
         " DBStorage=$" + row.db_storage_cost + 
         " VM_FS=$" + row.vm_fs_cost +
         " ECPU_Usage(" + row.ecpus_enabled_total + " ECPUs)=$" + row.ecpu_cost;
     if (row.flash_cache_cost > 0) {
         row.summaryText += " AddlFlash=$" + row.flash_cache_cost;
     }
     row.summaryText += ")";
     
     // For consistency with existing code, set UsageUnits_billed
     row.UsageUnits_billed = ecpus_for_license;
     
     // Compatibility fields for Batch.vue pro-rating, totals, and infrastructure table display
     // Map ExaScale cost buckets to the standard ODB fields used by downstream code
     row.dbserver_cost = Math.round( (row.rdma_cost + row.vm_fs_cost) * 100) / 100;  // infrastructure costs
     row.storage_cost = Math.round( (row.db_storage_cost + row.flash_cache_cost) * 100) / 100;  // storage costs
     row.Usage_cost = row.ecpu_cost;  // ECPU usage cost
     
     // Fields used by infrastructure table
     row.dbservers = row.num_vms + " VMs";
     row.storageservers = "Vault";
     row.UsageUnits_target = row.ecpus_enabled_total;
     row.UsageUnits_provisioned = row.ecpus_enabled_total;
     row.UsageUnits_available = row.num_vms * 200;  // max 200 ECPUs per VM
     row.Memory_available = Math.round(row.num_vms * 200 * 2.75 * 100) / 100;  // max memory if all ECPUs provisioned
     row.storage_total_available = row.database_storage_gb / 1000;  // convert GB to TB for display consistency
     row.storage_data_dg = "N/A (vault)";
     row.storage_reco_dg = "N/A";
     row.storage_sparse_dg = "N/A";
     row.storage_style = "ExaScale Vault";
  }
        
  return infrastructure;
}


export {aggregate_database_targets};
export {pick_exadata_shape};
export {calculate_exadata_config};
export {calculate_adbs_config};
export {pick_exascale_shape};
export {calculate_exascale_config};
